import { render } from "./ks-logo.vue?vue&type=template&id=922e70b8"
import script from "./ks-logo.vue?vue&type=script&lang=js"
export * from "./ks-logo.vue?vue&type=script&lang=js"
script.render = render

export default script